import {
  execExpressionNew,
  isExpression,
  isNewExpression,
  newScope,
  scope,
} from 'nges-common/src/layout/expressionUtil';
import { getValidExpression } from 'nges-common/src/layout/expressionScript';
import _ from 'lodash';

function execExpression(expressionStr, paramsObj = {}) {
  try {
    if (isNewExpression(expressionStr)) {
      expressionStr = expressionStr.substring(2, expressionStr.length - 2);
      return execExpressionNew(expressionStr, paramsObj, newScope);
    }
    if (isExpression(expressionStr)) {
      const validExpressionStr = getValidExpression(expressionStr);
      const paramsKeys = Object.keys(paramsObj);
      // eslint-disable-next-line no-new-func
      let execFunc = new Function(
        [].concat(paramsKeys).concat(Object.keys(scope)),
        validExpressionStr,
      );
      const paramsValues = Object.values(paramsObj);
      const result = execFunc(...[].concat(paramsValues).concat(Object.values(scope)));
      execFunc = null;
      return result;
    }
    return expressionStr;
  } catch (err) {
    console.error('expression str with error:', expressionStr);
    console.error('expression error:', err);
    throw err;
    // return `${expressionStr}:${err.toString()}`;
  }
}

export function execExpressionDeep(obj, paramsObj = {}) {
  if (_.isObject(obj)) {
    _.forEach(obj, (value, idx) => {
      const execResult = execExpressionDeep(value, paramsObj);
      obj[idx] = execResult;
    });
    return obj;
  }
  const result = execExpression(obj, paramsObj);
  return result;
}
